module.exports = __webpack_public_path__ + "img/nl-bg.77f4b40b.jpg";